module.exports = __webpack_public_path__ + "assets/img/favicon/ms-icon-310x310.a65df3b2c1dfa008984daa6ce650efa4.png";